import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Message.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Message = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 50%",
      },
    });

    timeline.to(textRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Message}>
      <Container>
        <p ref={textRef}>
          Dickinson’s athletics mascot wasn’t adopted until the 1930s when a
          journalist who reported on a hotly contested football game dubbed the
          red-and-white-wearing Dickinson athletes as “red devils” for their
          spirited play. The name stuck.
        </p>
      </Container>
    </div>
  );
};

export default Message;
